import { Link } from "react-router-dom";

/**
 * Breadcrumb HTML navigabile. Prima era solo dati invisibili (schema.org
 * BreadcrumbList in JSON-LD): utile a Google ma inutile a chi naviga il sito
 * e privo di link interni reali. Qui il markup e i testi sono la stessa
 * lista `items` già passata a `breadcrumb(items)` in data.js, così le due
 * cose restano sempre allineate senza doverle scrivere due volte.
 *
 * items: [{ name, path }] — "Home" è aggiunta automaticamente come primo nodo.
 */
export default function Breadcrumb({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav className="bc" aria-label="breadcrumb">
      <ol className="bc-list">
        <li>
          <Link to="/">Home</Link>
        </li>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={item.path}>
              <span className="bc-sep" aria-hidden="true">/</span>
              {isLast ? (
                <span className="bc-current" aria-current="page">{item.name}</span>
              ) : (
                <Link to={item.path}>{item.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
